function parseUser(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function loadUser() {
  for (const storage of [localStorage, sessionStorage]) {
    for (const key of ['rrpl_user', 'user']) {
      const u = parseUser(storage.getItem(key));
      if (u?.token) return u;
    }
  }
  return null;
}

export const state = {
  currentUser: loadUser(),
};

export const getters = {
  loggedIn: (s) => !!(s.currentUser && s.currentUser.token),
};

export const mutations = {
  SET_CURRENT_USER(state, { user, remember = true }) {
    state.currentUser = user;
    ['rrpl_user', 'user', 'jwt'].forEach((k) => {
      localStorage.removeItem(k);
      sessionStorage.removeItem(k);
    });
    if (!user) return;
    const payload = JSON.stringify(user);
    const storage = remember ? localStorage : sessionStorage;
    storage.setItem('rrpl_user', payload);
    storage.setItem('user', payload);
    if (user.token) storage.setItem('jwt', user.token);
  },
};

export const actions = {
  setSession({ commit }, { user, remember }) {
    commit('SET_CURRENT_USER', { user, remember: remember !== false });
  },

  logIn() {
    return Promise.resolve(null);
  },

  logOut({ commit }) {
    commit('SET_CURRENT_USER', { user: null, remember: true });
  },

  register() {
    return Promise.resolve();
  },

  resetPassword() {
    return Promise.resolve();
  },

  validate({ state, commit }) {
    const token = state.currentUser?.token;
    if (!token) return Promise.resolve(false);
    return import('@/services/api')
      .then(({ default: api }) => api.get('/api/v1/auth/me'))
      .then(() => true)
      .catch(() => {
        commit('SET_CURRENT_USER', { user: null, remember: true });
        return false;
      });
  },
};
